/** Move an array item from `from` to `to` index (immutable). */
export function moveItem<T>(arr: T[], from: number, to: number): T[] {
  if (from === to || from < 0 || to < 0 || from >= arr.length || to >= arr.length) return arr;
  const next = [...arr];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

/**
 * Preview shift direction for list slots while dragging `from` over `over`.
 * Peers between source and hover move up/down to open the drop gap.
 */
export function computeSlotShift(
  index: number,
  from: number | null,
  over: number | null,
): 'up' | 'down' | null {
  if (from == null || over == null || index === from) return null;
  if (from < over && index > from && index <= over) return 'up';
  if (from > over && index >= over && index < from) return 'down';
  return null;
}

/** Deep-clone a top-level block and insert it immediately after `index`. */
export function duplicateBlockAt<T>(arr: T[], index: number): T[] {
  if (index < 0 || index >= arr.length) return arr;
  const clone = JSON.parse(JSON.stringify(arr[index])) as T;
  const next = [...arr];
  next.splice(index + 1, 0, clone);
  return next;
}
